// import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";

function Switcher({ isMob }) {
    return (
        <div className="switcher_box">
            {isMob ? (
                <div className="top-nav">
                    <input id="menu-toggle" type="checkbox" />
                    <label class="menu-button-container" for="menu-toggle">
                        <div class="menu-button"></div>
                    </label>
                    <div className="header_name">
                        <img
                            src="https://res.cloudinary.com/dx9rdmmff/image/upload/v1761066426/Magda/heart-rate-monitor-computer-icons-computer-monitors-medical-ae3c721384a129dc6c04c8b0a99054e8_jwo5gi.png"
                            alt="header_icon"
                        />
                        <Link className="molszynska" to="/">
                            Magdalena Olszyńska
                        </Link>
                    </div>
                    <div className="menu">
                        <Link to="/" className="menu_item">
                            <h3>Strona główna</h3>
                        </Link>
                        <Link to="/about" className="menu_item">
                            <h3>O mnie</h3>
                        </Link>
                        <Link to="/job" className="menu_item">
                            <h3>Oferta</h3>
                        </Link>
                         <Link to="/publications" className="menu_item">
                            <h3>Publikacje</h3>
                        </Link>
                        <Link to="/opinions" className="menu_item">
                            <h3>Opinie</h3>
                        </Link>
                        <Link to="/contact" className="menu_item">
                            <h3>Kontakt</h3>
                        </Link>
                    </div>
                </div>
            ) : (
                <div className="switcher">
                    <div className="header_name">
                        <img
                            src="https://res.cloudinary.com/dx9rdmmff/image/upload/v1761066426/Magda/heart-rate-monitor-computer-icons-computer-monitors-medical-ae3c721384a129dc6c04c8b0a99054e8_jwo5gi.png"
                            alt="header_icon"
                        />
                        <Link to="/">Magdalena Olszyńska</Link>
                    </div>
                    <div className="switcher-list">
                        <Link to="/" className="menu_item">
                            <h3>Strona główna</h3>
                        </Link>
                        <Link to="/about" className="menu_item">
                            <h3>O mnie</h3>
                        </Link>
                        <Link to="/job" className="menu_item">
                            <h3>Oferta</h3>
                        </Link>
                        <Link to="/publications" className="menu_item">
                            <h3>Publikacje</h3>
                        </Link>
                        <Link to="/opinions" className="menu_item">
                            <h3>Opinie</h3>
                        </Link>
                        <Link to="/contact" className="menu_item">
                            <h3>Kontakt</h3>
                        </Link>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Switcher;
